import React, { ReactNode } from "react"
import ReadLearnCategory from "./ReadLearnCategory"
import { ICategory } from "../../contentful-types"
import { useContentfulConditionalGate } from "../../lib/contentful/components/ContentfulConditionGate"
import { FormattedMessage } from "react-intl"

import { SimpleGrid } from "@carrotfertility/carotene"

import { Redirect } from "react-router"
import slugify from "slugify"
import { PageLayout } from "features/global-ui/page-layout"
import { PageHeader, PageHeaderGlyph } from "features/global-ui/page-header"

type ReadLearnCategoryGridProps = {
  categories: Array<ICategory>
}

export const ReadLearnHomeMasterLayout = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <PageLayout
      header={
        <PageHeader
          startGlyph={
            <PageHeaderGlyph src="/images/icn-lightbulb-color.png" srcSet={"/images/icn-lightbulb-color-2x.png"} />
          }
          pageTitle={<FormattedMessage defaultMessage="Read & learn" />}
        />
      }
    >
      {children}
    </PageLayout>
  )
}

export default function ReadLearnLandingPageLayout({ categories }: ReadLearnCategoryGridProps): JSX.Element {
  const categoriesAndConditions = React.useMemo(
    () =>
      categories.map((category) => ({
        element: (
          <ReadLearnCategory key={`id-${category?.fields?.navTitle ?? category?.fields?.title}`} category={category} />
        ),
        conditions: category?.fields?.conditions,
        category
      })),
    [categories]
  )
  const readAndLearnCategories = useContentfulConditionalGate(categoriesAndConditions)
  if (readAndLearnCategories.length === 1) {
    const matchingCategory = categoriesAndConditions.find(
      (categoryTuple) => categoryTuple.element === readAndLearnCategories[0]
    ).category
    return <Redirect to={`/read/${slugify(matchingCategory.fields.navTitle)}`} />
  }

  return (
    <ReadLearnHomeMasterLayout>
      <SimpleGrid spacing={["medium", "medium", "32px"]} columns={[1, 2, 2, 3]}>
        {readAndLearnCategories}
      </SimpleGrid>
    </ReadLearnHomeMasterLayout>
  )
}
